import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation, inject } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { InputNumberModule } from 'primeng/inputnumber';
import { SelectModule } from 'primeng/select';
import { CoordinatesFormat } from 'src/app/model/map.model';
import {
  validateDecimalLatitude,
  validateDecimalLongitude,
  validateLatitude,
  validateLongitude
} from 'src/app/shared/form/validators';
import { InputTextModule } from 'primeng/inputtext';
import { ValidatorComponent } from 'src/app/ui/validator/validator.component';
import { AdhocService } from 'src/app/services/adhoc.service';
import { CircleFormGroup } from 'src/app/model/adhoc.model';

@Component({
  selector: 'rqa-add-circle',
  templateUrl: './add-circle.component.html',
  styleUrls: ['./add-circle.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ButtonModule,
    InputNumberModule,
    InputTextModule,
    SelectModule,
    TranslateModule,
    ValidatorComponent
  ],
  encapsulation: ViewEncapsulation.None
})
export class AddCircleComponent implements OnInit, OnChanges {
  @Input() circleForm: CircleFormGroup;
  @Input() coordinatesFormat: CoordinatesFormat;
  coordinatesType = CoordinatesFormat;
  coordsMaxLength: number = 6;
  form: FormGroup;
  units: { value: string; label: string }[] = [
    { value: 'km', label: 'km' },
    { value: 'm', label: 'm' },
    { value: 'NM', label: 'nm' }
  ];
  private adhocService = inject(AdhocService);

  ngOnInit(): void {
    this.setCoordinatesValidators(this.coordinatesFormat);
  }

  ngOnChanges(changes: SimpleChanges) {
    const coordinatesFormat = changes['coordinatesFormat']?.currentValue;
    if (coordinatesFormat) {
      this.coordsMaxLength = coordinatesFormat === CoordinatesFormat.DMS ? 6 : 7;
    }
    if (this.circleForm) {
      this.setCoordinatesValidators(coordinatesFormat);
    }
    if (changes['resetForm']?.currentValue) {
      this.clear();
    }
  }

  clear(): void {
    this.circleForm.reset();
    this.adhocService.setCircleToDraw(null);
  }

  draw(): void {
    if (this.circleForm.valid) {
      const formData = this.circleForm.getRawValue();
      this.adhocService.setCircleToDraw(formData);
    }
  }

  private setCoordinatesValidators(formatType: CoordinatesFormat): void {
    if (formatType === CoordinatesFormat.DMS) {
      this.circleForm
        .get('latitude')
        ?.setValidators([Validators.required, Validators.minLength(6), validateLatitude()]);
      this.circleForm
        .get('longitude')
        ?.setValidators([Validators.required, Validators.minLength(6), validateLongitude()]);
    }
    if (formatType === CoordinatesFormat.DECIMAL) {
      this.circleForm
        .get('latitude')
        ?.setValidators([Validators.required, Validators.minLength(7), validateDecimalLatitude()]);
      this.circleForm
        .get('longitude')
        ?.setValidators([Validators.required, Validators.minLength(7), validateDecimalLongitude()]);
    }
  }
}
